declare global {
    interface Window {
        dataLayer: Record<string, unknown>[];
    }
}

let initialized = false;

export function initGtm(tag: string): void {
    if (initialized) {
        return;
    }

    initialized = true;
    window.dataLayer = window.dataLayer || [];
    pushGtm({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${tag}`;

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);
}

export function pushGtm(data: Record<string, unknown>): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}
